module.exports = __webpack_public_path__ + "static/media/fotos.6c0ededa.svg";